<template>
    <div id="layoutSidenav_nav">
        <nav class="sb-sidenav accordion sb-sidenav-dark" id="sideNavBar">
            <div class="sb-sidenav-menu">
                <div class="nav ml-3">
                    <router-link
                        class="nav-link mt-4 fs-18"
                        v-bind:to="{ name: 'adm' }" exact>
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-tachometer-alt fs-20"></i>
                        </div>
                        Painel
                    </router-link>

                    <div class="sb-sidenav-menu-heading">
                        Operações
                    </div>

                    <!-- Collapse Financeiro -->
                    <a
                        class="nav-link collapsed fs-18"
                        href="#"
                        data-toggle="collapse"
                        data-target="#collapseFinanceiro"
                        aria-expanded="false"
                        aria-controls="collapseFinanceiro">
                        <div class="sb-nav-link-icon">
                            <!--<i class="fas fa-columns"></i>-->
                            <i class="fas fa-dollar-sign"></i>
                        </div>
                        Financeiro
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>
                    <div
                        class="collapse"
                        id="collapseFinanceiro"
                        aria-labelledby="headingOne"
                        data-parent="#sideNavBar">
                        <nav
                            class="sb-sidenav-menu-nested nav">
                            <!-- Geral -->
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'financeiro' }">
                                Geral
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'receita' }">
                                Receita
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'despesa' }">
                                Despesas
                            </router-link>

                            <!-- Collapse Receita -->
                            <!--
                            <a
                                class="nav-link collapsed"
                                href="#"
                                data-toggle="collapse"
                                data-target="#collapseReceita"
                                aria-expanded="false"
                                aria-controls="collapseReceita">
                                <div class="sb-nav-link-icon">
                                    <i class="fas fa-dollar-sign"></i>
                                </div>
                                Receita
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fa-angle-down"></i>
                                </div>
                            </a>
                            <div
                                class="collapse"
                                id="collapseReceita"
                                aria-labelledby="headingOne"
                                data-parent="#collapseFinanceiro">
                                <router-link
                                    class="nav-link fs-18"
                                    v-bind:to="{ name: 'receita' }">
                                    Receita
                                </router-link>
                            </div>
                        -->

                            <!-- Collapse Despesa -->
                            <!--
                            <a
                                class="nav-link collapsed"
                                href="#"
                                data-toggle="collapse"
                                data-target="#collapseDespesa"
                                aria-expanded="false"
                                aria-controls="collapseDespesa">
                                <div class="sb-nav-link-icon">
                                    <i class="fas fa-dollar-sign"></i>
                                </div>
                                Despesa
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fa-angle-down"></i>
                                </div>
                            </a>
                            <div
                                class="collapse"
                                id="collapseDespesa"
                                aria-labelledby="headingOne"
                                data-parent="#collapseFinanceiro">
                                <router-link
                                    class="nav-link fs-18"
                                    v-bind:to="{ name: 'despesa' }">
                                    Despesas
                                </router-link>
                            </div>

                        -->
                        </nav>
                    </div>

                    <!-- Collapse Pedidos -->
                    <a
                        class="nav-link collapsed fs-18"
                        href="#"
                        data-toggle="collapse"
                        data-target="#collapsePedidos"
                        aria-expanded="false"
                        aria-controls="collapsePedidos">
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-paste"></i>
                        </div>
                        Pedidos
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>
                    <div
                        class="collapse"
                        id="collapsePedidos"
                        aria-labelledby="headingOne"
                        data-parent="#sideNavBar">
                        <nav
                            class="sb-sidenav-menu-nested nav">
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'pedidos' }">
                                Principal
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'pedidoPagar' }">
                                A Pagar
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'pedidoArquivado' }">
                                Arquivados
                            </router-link>
                        </nav>
                    </div>


                    <!-- Collapse Relatorios -->
                    <a
                        class="nav-link collapsed fs-18"
                        href="#"
                        data-toggle="collapse"
                        data-target="#collapseRelatorios"
                        aria-expanded="false"
                        aria-controls="collapseRelatorios">
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-file-alt"></i>
                        </div>
                        Relatórios
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>
                    <div
                        class="collapse"
                        id="collapseRelatorios"
                        aria-labelledby="headingOne"
                        data-parent="#sideNavBar">
                        <nav
                            class="sb-sidenav-menu-nested nav">
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'relatorioPedido' }">
                                Pedidos
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'relatorioProduto' }">
                                Produtos
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'relatorioCategoriaProduto' }">
                                Categorias de Produtos
                            </router-link>
                            <router-link
                                class="nav-link fs-15"
                                v-bind:to="{ name: 'relatorioCliente' }">
                                Clientes
                            </router-link>
                        </nav>
                    </div>

                    <!-- Produtos -->
                    <router-link
                        class="nav-link fs-18"
                        v-bind:to="{ name: 'produtos' }">
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-shopping-bag"></i>
                        </div>
                        Produtos
                    </router-link>

                    <!-- Clientes -->
                    <router-link
                        class="nav-link fs-18"
                        v-bind:to="{ name: 'cliente' }" exact>
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-users"></i>
                        </div>
                        Clientes
                    </router-link>

                    <!-- Entregas -->
                    <router-link
                        class="nav-link fs-18"
                        v-bind:to="{ name: 'entregas' }">
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-car-side"></i>
                        </div>
                        Entregas
                    </router-link>
                </div>
            </div>
            <div class="sb-sidenav-footer">
                <a
                    href="https://orbitsuniverse.com.br/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary btn-block text-white">
                    <i class="fas fa-headset mr-2"></i>
                    Criar chamado
                </a>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    mounted() {
        document.body.classList.add('sb-nav-fixed');
    }
}
</script>

<style scoped>
#layoutSidenav_nav,
.sb-sidenav {
    overflow: hidden;
}

.sb-sidenav-menu {
    overflow-y: auto;
    -ms-overflow-style: none; /* IE e Edge */
    scrollbar-width: none; /* Firefox */
}

.sb-sidenav-menu::-webkit-scrollbar {
    display: none; /* Chrome, Safari e Opera */
}
</style>
